// extracted by mini-css-extract-plugin
module.exports = {"container":"AgeEstimationFallbackDialog_container__bHTjG","title":"AgeEstimationFallbackDialog_title__W21iU","description":"AgeEstimationFallbackDialog_description__HitCl"};